import { NumberInput } from '@/components';
import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import type { TouchPointFormData } from '../TouchPointModal';

interface PhonePropertiesSectionProps {
  register: UseFormRegister<TouchPointFormData>;
  errors: FieldErrors<TouchPointFormData>;
}

export function PhonePropertiesSection({ register, errors }: PhonePropertiesSectionProps) {
  return (
    <div className="space-y-6 pt-4 border-t border-slate-200 dark:border-slate-600 md:border-0 md:pt-0">
      <h3 className="text-lg font-medium text-slate-900 dark:text-white">
        Phone Properties
      </h3>

      <NumberInput
        label="Number of Dials"
        required
        min={1}
        placeholder="1"
        error={errors.NumberOfDials?.message}
        {...register('NumberOfDials', {
          required: 'Number of dials is required',
          valueAsNumber: true,
          min: { value: 1, message: 'Number of dials must be at least 1' }
        })}
      />
    </div>
  );
}
